
import {validUtil} from './valid'
import {cookieUtil} from "./cookie";
import {util} from './utils'

export const SessionUtil = function () {
  this.loadCacheProject = false // 是否加载缓存项目
  this.authCacheKey = 'cache-auths'
  this.menuCacheKey = 'cache-menus'
  this.btnCacheKey = 'cache-btns'
  this.roleCacheKey = 'cache-roles'
  this.sessionCacheKey = 'cache-session'
  this.licenseCacheKey = 'cache-license'
  this.commonConfCacheKey = 'cache-common-conf' // 公共配置
  this.oauthInfoCacheKey = 'cache-oauth'
  this.refreshStatus = 'refresh-status'
  this.indexMenuCacheKey = 'index-menu' // 登录首页菜单
  this.projectMenuCacheKey = 'project-menu' // 项目菜单菜单
  this.orgConf = 'org-conf' // 企业私有配置

  this.getOrgConfByKey = function(key) {
    if(key.startWith('org-conf-')){
      key = key.substring(9)
    }
    // console.log('-----key-----',key)
    let data = this.getOrgConf()
    if(data && data[key]){
      return data[key].value
    }else{
      // 说明key不存在
      if(key === 'ims.wf.contract.index'){
        return 1
      }else if(key === 'ims.wf.contract.node.quarter-plan.enable'){
        return false
      }else if(key === 'ims.wf.contract.node.year-plan.enable'){
        return false
      }else if(key === 'ims.wf.contract.node.purchase-plan.enable'){
        return false
      }else if(key === 'ims.wf.sporadic.index'){
        return 1
      }
    }
    return null
  }

  this.getOrgConf = function(){
    var data = window.cache_org_conf != undefined ? window.cache_org_conf : null
    if (data == undefined || data == null) {
      return cookieUtil.get(this.orgConf)
    }
    return data
  }
  this.initOrgConf = function(srcData){
    let data = {}
    if(srcData){
      srcData.forEach(item => {
        data[item.key] = item
      })
    }
    window.cache_org_conf = data
    cookieUtil.set(this.orgConf, data, 7200)
  }
  this.initSession = function (res) {
    // console.log('--------initSession----------')
    var roleList = res.data.roleList
    if (roleList != undefined && roleList != null) {
      delete res.data.roleList
      cookieUtil.set(this.roleCacheKey, roleList, res.data['expire'])
      window.cache_roles = roleList
    }
    res.data['access_token'] = res['access_token']
    res.data['create_time'] = res['create_time']
    res.data['expire'] = res['expire']
    res.data['over_time'] = res['over_time']
    window.cache_session = res.data
    cookieUtil.set(this.sessionCacheKey, res.data, res.data['expire'])
  }
  this.getSession = function () {
    var data = window.cache_session
    if (!data) {
      data = cookieUtil.get(this.sessionCacheKey)
    }
    return data
  }
  this.removeSession = function () {
    cookieUtil.clear(this.sessionCacheKey)
    window.cache_session = null
    window.cache_roles = null
    window.cache_auths = null
    window.cache_menus = null
    window.cache_menus_code = null
    window.cache_btns = null
    cookieUtil.clearAll()
  }
  this.refreshToken = function (vue, token, operateType) {
    // console.log('-------refreshToken------',operateType)
    // alert(operateType);
    let params = {ifRefresh: true}
    var _this = vue
    if (operateType) {
      // alert(111)
      util.mask('正在登陆...')
    }
    vue.util.restPost('/api_v1/refresh_token?loginType=0&access_token=' + token, params, (res) => {
      if (res.status === 200) {
        if (vue.loading) {
          vue.loading = false
        }
        _this.cookieUtil.clear('LoginOut')
        if (res.auths != null) {
          var auths = res.auths
          _this.sessionUtil.initAuths(auths)
        }
        _this.sessionUtil.initSession(res)
        var session = this.getSession()
        // alert(1111);
        // console.log('-------------------'+JSON.stringify(session.user))
        // 如果是微信pc端跳转
        if (operateType) {
          if (res.license) {
            _this.$bus.emit('get-license', res.license)
            if (vue.sessionUtil.isCloud() && !vue.sessionUtil.isAllowLogin()) {
              vue.$bus.emit('on-show-license-msg', 2)
              vue.util.unmask()
              return false
            }
          } else {
            _this.$bus.emit('get-license')
          }
          _this.$store.state.userName = _this.sessionUtil.getUserName()
          _this.$store.state.userUid = _this.sessionUtil.getUserUid()
          _this.$store.state.userId = _this.sessionUtil.getUserId()
          _this.$store.state.companyUid = _this.sessionUtil.getCompanyUid()
          _this.$store.state.departUid = _this.sessionUtil.getDepartUid()
          if (process.env.NODE_ENV !== 'production') {
            //_this.$router.push({path: '/proj'})
            let url = 'http://192.168.0.5:8080/#/page/index'
            console.log('----url-----'+url)
            _this.$router.push({path: '/page/index'});
           /* setTimeout(()=>{
              window.location.href = url
            },10);*/
            //window.location.href = url

            /*_this.$bus.emit('update-logo')
            // 获取企业私有配置
            // getOrgConf(this);
            _this.$bus.emit('initTree');
            _this.$router.push({path: '/page/index'});

*/
            return;
          } else {
            /*let url = _this.util.getBaseUrl() + '#/page/index'
            console.log('----url-----'+url)
            window.location.href = url*/
            _this.$router.push({path: '/page/index'});
            return
          }
          // window.location.href=_this.util.getBaseUrl()+"#/page/index"

          setTimeout((params) => {
            // 跳转页面
            _this.$bus.emit('initTree')

            // this.loadApproval();
            // 获取当前项目线索
            // this.getCurrentSynergy();
          }, 500)
          _this.$router.options.routes.forEach((item) => {
            if (item.meta) {
              item.meta.keepAlive = false
            }
          })
          vue.$store.commit('clearRouteList') // 清空标签缓存
          sessionStorage.removeItem('routerParams')
        }
      } else {
        this.removeSession()
      }
    }, false)
  }
  this.checkToken = function (vue) {
    // console.log('-----checkToken----',window,vue)
    // console.log(new Date().format('hh:mm:ss')+'-----checkToken----')
    // if(vue.$route && vue.$route)
    // let refreshStatus = window.localStorage.getItem(this.refreshStatus)
    let refreshStatus = cookieUtil.get(this.refreshStatus)
    if (refreshStatus === undefined || refreshStatus === null) {
      // window.localStorage.setItem(this.refreshStatus,1)
      cookieUtil.set(this.refreshStatus, 1, 30)

      let session = this.getSession()
      // console.log('-----checkToken--session--',session)
      if (session != null) {
        // console.info('----0----',new Date(session.create_time).format('hh:mm:ss'))
        // 判断是否过期
        var createTimeStr = session['createTime']
        var expire = session['expire']
        var createTime = new Date(createTimeStr)

        var nowTime = new Date()
        var times = nowTime.getTime() - createTime.getTime()

        var expireTimes = (parseInt(expire) - TOKEN_INTERCAL_MINUTE * 60) * 1000 // 允许误差20分钟
        // console.info(nowTime);
        // console.info(createTime);
        // console.info(times + "==" + (times < expireTimes) + "==" + expireTimes);
        if (times < expireTimes) {
          console.info('======1=====', times, expireTimes)
        } else {
          console.info('======2=====')
          // 如果过期就重新刷新,调用login页面的监听
          // vue.$bus.$emit('refresh_token',{ifRefresh:true, access_token:session.token})
          this.refreshToken(vue, session.token)
        }
      }
      /*
      setTimeout(()=>{
        // window.localStorage.removeItem(this.refreshStatus)
      },5000) */
    } else {
      console.log('-----checkToken--2--有标签页正在执行')
    }
  }
  this.initOauth = function (data) {
    cookieUtil.set(this.oauthInfoCacheKey, data, 7200)
  }
  this.clearOauth = function () {
    cookieUtil.clear(this.oauthInfoCacheKey)
  }
  this.getOauthInfo = function () {
    return cookieUtil.get(this.oauthInfoCacheKey)
  }
  this.isCloud = function () {

    if(window._isCloud != undefined){
      return window._isCloud
    }

    let data = this.getOauthInfo()
    if (data != null) {
      return data['isCloud']
    }
    return false
  }
  this.initLicense = function (data) {
    cookieUtil.set(this.licenseCacheKey, data, 7200)
  }
  this.clearLicense = function () {
    cookieUtil.clear(this.licenseCacheKey)
  }
  this.getLicense = function () {
    return cookieUtil.get(this.licenseCacheKey)
  }
  this.initCommonConf = function(data){
    cookieUtil.set(this.commonConfCacheKey, data, 7200)
  }
  this.getCommonConf = function () {
    return cookieUtil.get(this.commonConfCacheKey)
  }
  this.getFileAcceptLength = function () {
    let config = this.getCommonConf();
    if(config){
      return config['sys.file.accept.length']
    }
    return null
  }
  /**
   * 获取全局小数位
   * @returns {*}
   */
  this.getDecimalDigit = function () {
    let config = this.getCommonConf();
    if(config){
      return Number(config['sys.form.decimal-digit']);
    }
    return 2;
  }
  /**
   * 对于已审单据（包含未走流程）是否开启抄送功能
   * @returns {*|boolean}
   */
  this.isAllowWfFinishedCopy = function () {
    let config = this.getCommonConf();
    if(config){
      return config['sys.wf.finished.copy.enable'] && config['sys.wf.finished.copy.enable'] == '1'
    }
    return false
  }
  this.getTelephone = function () {
    let license = this.getLicense()
    if (license) {
      return license.telephone
    }
  }
  this.isAllowAddUser = function () {
    let license = this.getLicense()
    if (license) {
      return license['allowAddUser']
    }
    return false
  }
  this.isAllowUpload = function () {
    let license = this.getLicense()
    if (license) {
      return license['allowUpload']
    }
    return false
  }
  this.isAllowLogin = function () {
    let license = this.getLicense()
    if (license) {
      return license['allowLogin']
    }
    return false
  }
  this.isProVersion = function () {
    let data = this.getLicense()
    if (data != null) {
      return !data['expire']
    }
    return false
  }
  /**
   * 登陆后设置权限信息
   */
  this.initAuths = function (data) {
    cookieUtil.set(this.authCacheKey, data, 7200)
    window.cache_auths = data
    // console.info("===========" + cookieUtil.get(this.authCacheKey));
    this.initMenus(data)
  }
  this.getAuths = function (data) {
    var data = window.cache_auths != undefined ? window.cache_auths : null
    if (data == undefined || data == null) {
      return cookieUtil.get(this.authCacheKey)
    }
    return data
  }
  /**
   * 递归菜单
   */
  this.deepMenu = function (menuMap, menuCodeMap, resourceMap, parent, data) {
    var _this = this
    data.forEach(function (item, index) {
      // console.log('----item---',item.id,item.title)
      if (item.resourceType == 4) {
        // 说明是按钮
        if(item.code.indexOf('@') > -1) {
          resourceMap[item.code] = item
        } else {
          resourceMap[parent.code + ':' + item.code] = item
        }
      }else {
        // 说明是菜单
        if (validUtil.isNotEmpty(item.path)) {
          menuMap[item.path] = item
        } else {
          // 判断是否配置表单
        }
        menuCodeMap[item.code] = item
        if (item.children !== undefined) {
          _this.deepMenu(menuMap, menuCodeMap, resourceMap, item, item.children)
        }
      }
    })
  }
  /**
   * 初始化菜单和按钮到缓存
   */
  this.initMenus = function (data) {
    // console.log('---------initMenus----------', data)
    if (data !== undefined) {
      var menuCodeMap = {}
      var menuMap = {}
      var resourceMap = {}
      this.deepMenu(menuMap, menuCodeMap, resourceMap, null, data)
      cookieUtil.set(this.menuCacheKey, menuMap, 7200)
      cookieUtil.set(this.btnCacheKey, resourceMap, 7200)
      cookieUtil.set(this.menuCodeCacheKey, menuCodeMap, 7200)
      window.cache_menus = menuMap
      window.cache_menus_code = menuCodeMap
      window.cache_btns = resourceMap
      let indexMenus = []
      let projMenus = []
      // 组装首页菜单
      data.forEach(item => {
        if (item.category && (item.category === 1 || item.category === 2)) {
          indexMenus.push(item)
        } else {
          projMenus.push(item)
        }
      })

      cookieUtil.set(this.projectMenuCacheKey, projMenus, 7200)
      window.cache_project_menus = projMenus
      cookieUtil.set(this.indexMenuCacheKey, indexMenus, 7200)
      window.cache_index_menus = indexMenus
    } else {
      cookieUtil.remove(this.menuCacheKey)
      cookieUtil.remove(this.menuCodeCacheKey)
      cookieUtil.remove(this.btnCacheKey)
      window.cache_menus = null
      window.cache_menus_code = null
      window.cache_btns = null
    }
  }
  /**
   * 获取缓存的菜单
   */
  this.getMenus = function () {
    var data = window.cache_menus != undefined ? window.cache_menus : null
    if (data == undefined || data == null) {
      return cookieUtil.get(this.menuCacheKey)
    }
    return data
  }
  /**
   * 获取首页菜单
   * @returns {*}
   */
  this.getIndexMenus = () => {
    var data = window.cache_index_menus != undefined ? window.cache_index_menus : null
    if (data === undefined || data === null) {
      return cookieUtil.get(this.indexMenuCacheKey)
    }
    return data
  }
  /**
   * 获取项目菜单
   * @returns {*}
   */
  this.getProjectMenus = () => {
    var data = window.cache_project_menus != undefined ? window.cache_project_menus : null
    if (data === undefined || data === null) {
      return cookieUtil.get(this.projectMenuCacheKey)
    }
    return data
  }
  this.getRoles = function () {
    var data = window.cache_roles != undefined ? window.cache_roles : null
    if (data == undefined || data == null) {
      return cookieUtil.get(this.roleCacheKey)
    }
    return data
  }
  this.getBtns = function () {
    var data = window.cache_btns != undefined ? window.cache_btns : null
    if (data == undefined || data == null) {
      return cookieUtil.get(this.btnCacheKey)
    }
    return data
  }

  this.getAccessToken = function (vue) { // 获取token
    
    if (!cookieUtil.validToken() && !cookieUtil.get('register')) {
      util.vue.$router.push({ path: '/login' })
      return null
    }
    if(window.location.href.indexOf('/sso') != -1 ){
      let token =window.localStorage.getItem("access_token");
      return token;
    }
    var session = this.getSession()
    
    if (session != null) {
      return session.access_token
    }else {
      if(window.location.href.indexOf('/login') != -1 ){
        return null;
      }
      if (  window.location.href.indexOf('/redirect') != -1) {
        return null
      }
      // 说明过期了
      util.gotoLogin()
    }
    return null
  }
  this.getCorpId = function () {
    var session = this.getSession()
    if (session != null) {
      return session.corpId
    }
    return null
  }
  this.getAgentId = function () {
    if(validUtil.isNotNull(window.agent_id)){

      return window.agent_id
    }
    var session = this.getSession()
    if (session != null) {
      return session.agentId
    }
    return null;
  }
  this.getAppId = function () { // 获取系统所属应用id
    return window.app_id
  }
  this.getApp = function () { // 获取系统所属应用id
    // console.log('-----11-----',window.app, typeof window.app)
    if(window.app && typeof window.app != 'object'){
      return window.app
    }
    return null
  }
  this.getSysName = function(){
    return window.sys_name
  }
  this.getCompanyUid = function (vue) { // 当前登录人所属组织编码
    var session = this.getSession()
    if (session != null) {
      return session.company.id
    }
    return null
  }
  this.getCompanyId = function (vue) { // 当前登录人所属组织编码
    var session = this.getSession()
    if (session != null) {
      return session.company.departId
    }
    return null
  }
  this.getCompanyName = function (vue) { // 当前登录人所属组织编码
    var session = this.getSession()
    if (session != null) {
      return session.company.departName
    }
    return null
  }
  this.getSubCompanyName = function (vue) { // 当前登录人所属组织编码
    var session = this.getSession()
    if (session != null) {
      return session.subCompany && session.subCompany.departName
    }
    return null
  }
  this.getSubCompanyUid = function (vue) { // 当前登录人所属组织编码
    var session = this.getSession()
    if (session != null) {
      return session.subCompany && session.subCompany.id
    }
    return null
  }
  this.getUser = function (vue) { // 当前登录人人
    var session = this.getSession()
    if (session != null) {
      return session.user
    }
    return null
  }
  this.getMobile = function () {
    let user = this.getUser()
    if (user) {
      return user.mobileNo
    }
    return null
  }
  this.getEmail = function () {
    let user = this.getUser()
    if (user) {
      return user.email
    }
    return null
  }
  this.getPositionUid = function (vue) { // 当前登录人所属职位编码
    var session = this.getSession()
    if (session != null) {
      return session.position && session.position.id
    }
    return null
  }
  this.getPositionId = function (vue) { // 当前登录人所属职位编码
    var session = this.getSession()
    if (session != null) {
      return session.position && session.position.id
    }
    return null
  }
  this.getPositionName = function (vue) { // 当前登录人所属职位名称
    var session = this.getSession()
    if (session != null) {
      return session.position && session.position.positionName
    }
    return null
  }
  this.getOtherPositions = function (vue) { // 当前登录人所属职位名称
    var session = this.getSession()
    if (session != null) {
      let currentId = this.getSubCompanyUid()
      let positions = session.positions
      // console.log(currentId+'------getPositions-------',positions)
      if(positions){
        positions = positions.filter(item=>{
          item.activated = (item.subCompany === currentId)
          return (item.subCompany !== currentId)
        });
        // console.log(currentId+'------getPositions----2---',positions)
        return positions;
      }
    }
    return []
  }
  this.getDefaultAvatar = function(vue) {
    return require('../assets/login/DefaultAvatar.png')
  }
  this.getAvatar = function (vue) { // 当前登录人编码
    var user = this.getUser(vue)
    if (user && user.picture) {
      return user.picture
    }
    return require('../assets/login/DefaultAvatar.png')
  }
  this.getUserId = function (vue) { // 当前登录人编码
    var session = this.getSession()
    if (session != null) {
      return session.user.userId
    }
    return null
  }
  this.getUserUid = function (vue) { // 当前登录人主键
    var session = this.getSession()
    if (session != null) {
      return session.user.id
    }
    return null
  }
  this.getUserName = function (vue) { // 当前登录人名称
    var session = this.getSession()
    if (session != null) {
      return session.user.userName
    }
    return null
  }
  this.getDepartUid = function (vue) { // 当前登录人部门主键
    var session = this.getSession()
    if (session != null) {
      return session.depart && session.depart.id
    }
  }
  this.getDepartId = function (vue) { // 当前登录人部门编码
    var session = this.getSession()
    if (session != null) {
      return session.depart && session.depart.departId
    }
  }
  this.getDepartName = function (vue) { // 当前登录人部门名称
    var session = this.getSession()
    if (session != null) {
      return session.depart && session.depart.departName
    }
  }
  this.getCurrentData = function(vue){ // 获取当前人信息
    let data = {
      'current-user-uid': this.getUserUid(vue) || '',
      'current-user-name': this.getUserName(vue) || '',
      'current-depart-uid': this.getDepartUid(vue) || '',
      'current-depart-name': this.getDepartName(vue) || '',
      'current-company-uid': this.getCompanyUid(vue) || '',
      'current-company-name': this.getCompanyName(vue) || '',
    }
    return data
  }
  this.updateProjectCacheStatus = function(status){ // 例如总包PM等需要选择项目的则需要true,其他则为false
    this.loadCacheProject = status
  }
  this.deleteProjInfo = function(vue){
    // console.log('------deleteProjInfo-----')
    cookieUtil.clear('_session_proj' + this.getUserUid())
  }
  this.setProjInfo = function(info,vue){
    cookieUtil.set('_session_proj' + this.getUserUid(),info,60*60*1000*24*30)
  }
  this.getProjInfo = function (vue) { // 获取当前项目
    // console.log('------getProjInfo-----',this.loadCacheProject)
    // 判断如果是非选择项目的模块直接返回空
    // if(!this.loadCacheProject){
    //   return null
    // }
    let sessionProj =cookieUtil.get('_session_proj' + this.getUserUid());
    if (sessionProj) {
      return JSON.parse(sessionProj);
    }
    return null
  }
  this.getProjUid = function (vue) { // 获取当前项目id
    let sessionProj =this.getProjInfo(vue);
    if (sessionProj) {
      return sessionProj.PROJ_UID_
    }
    return null
  }
  this.getProjName = function (vue) { // 获取当前项目id
    let sessionProj =this.getProjInfo(vue);
    if (sessionProj) {
      return sessionProj.PROJ_NAME_
    }
    return null
  }
  this.isAllowMenu = function (resourceId) { // 是否有菜单权限
    if (resourceId == '/page/index') {
      return true
    }
    if (this.isAdmin()) {
      return true
    }
    // 判断是否公司管理员
    if (this.isCompanyAdmin()) {
      return true
    }
    // 判断某个资源是否有权限
    var data = this.getMenus()
    if (data != undefined && data != null) {
      if (data[resourceId] != undefined && data[resourceId] != null) {
        return true
      }
    }
    return false
  }
  this.isAllowBtn = function (formKey, resourceId) { // 是否有按钮权限
    return this.isAllow(formKey, resourceId)
  }
  this.isAllowAdd = function (formKey) { // 是否有新增按钮权限
    return this.isAllow(formKey, 'btnAdd')
  }
  this.isAllowEdit = function (formKey) { // 是否有编辑按钮权限
    return this.isAllow(formKey, 'btnEdit')
  }
  this.isAllowDelete = function (formKey) { // 是否有删除按钮权限
    return this.isAllow(formKey, 'btnDelete')
  }
  this.isAllowExport = function (formKey) { // 是否有导出按钮权限
    return this.isAllow(formKey, 'btnExport')
  }
  /**
   * 兼容旧的做法
   * @param resourceId
   * @returns {boolean}
   */
  this.isAllow = (formKey, resourceId) => {
    // console.log('---------------isAllow--------------', formKey, resourceId)
    if (this.isAdmin()) {
      return true
    }
    if (this.isCompanyAdmin()) {
      return true
    }
    if (this.isSubAdmin()) {
      return true
    }
    if (resourceId) {
      let vm = util.vue || Vue
      if (validUtil.isNotNull(formKey)) {
        try {
          vm.$store.dispatch('getFormAuths', formKey)
          let auths = vm.$store.state.formAuths[formKey]
          // console.log(formKey+'-----isAllow-------',auths )
          if (auths && auths[resourceId]) {
            return true
          } else {
            return false
          }
        } catch (error) {
          return false
        }
      }
    }
    // console.log('----------isAllow------end----')
    return false
  }
  this.isAllowBtn = function (resourceId) { // 是否有按钮权限
    // 判断是否公司管理员
    // console.info("======isAllowBtn=====",resourceId ,this.isCompanyAdmin());
    if (this.isAdmin()) {
      return true
    }
    if (this.isCompanyAdmin()) {
      return true
    }
    if (this.isSubAdmin()) {
      return true
    }
    // 判断某个资源是否有权限
    var data = this.getBtns()
    // console.info("getBtns========",data);
    if (data !== undefined && data !== null) {
      if (data[resourceId] !== undefined && data[resourceId] !== null) {
        return true
      }
    }
    return false
  }
  this.containRole = function (key) { // 是否包含角色
    var data = this.getRoles()
    if (data !== undefined && data != null) {
      for (var i = 0; i < data.length; i++) {
        var role = data[i].roleId
        if (role === key) {
          return true
        }
      }
    }
    return false
  }
  this.isAdmin = function () { // 公司管理员
    if (this.containRole('ROLE_ADMIN')) {
      return true
    }
    return false
  }
  this.isCompanyAdmin = function () { // 公司管理员
    if (this.containRole('ROLE_COMPANY_ADMIN')) {
      return true
    }
    return false
  }
  this.isSubAdmin = function () { // 分部管理员
    if (this.containRole('ROLE_SUB_ADMIN')) {
      return true
    }
    return false
  }
  this.isPm = function () { // 项目经理
    if (this.containRole('ROLE_COMPANY_PM')) {
      return true
    }
    return false
  }
  this.isHr = function () { // HR
    if (this.containRole('ROLE_COMPANY_HR')) {
      return true
    }
    return false
  }
  this.isCm = function () { // 合同专员
    if (this.containRole('ROLE_COMPANY_CM')) {
      return true
    }
    return false
  }
  this.isCashier = function () { // 出纳
    if (this.containRole('ROLE_COMPANY_CASHIER')) {
      return true
    }
    return false
  }
  /**
   * 判断页面中是否需要通过微信的wx-open-data组件渲染数据
   * @param openid
   * @returns {boolean}
   */
  this.isWxOpenData = function(openid){
    // let trustDomain = 'jz.zhuzhu.biz:7901';
    let url = window.location.href;
    // 判断是否可信域名，如果是
    if(this.isCloud()){//} && url.indexOf(trustDomain)>-1){
      // 如果没有包含中文，说明一定是微信数据通过过来了id
      if(!util.isChinese(openid)){
        return true;
      }
    }
    return false;
  }
  /**
   * 是否总部组织
   * @returns {boolean}
   */
  this.isMain = function(){
    return !this.isSub();
  }
  /**
   * 是否分部组织
   * @returns {boolean}
   */
  this.isSub = function(){
    var session = this.getSession()
    if (session != null) {
      return session['sub'] === undefined?false:session['sub']
    }
    return false;
  }
    this.getConstValue = function  (vue,key) { // 根据key获取常量值
      // console.log('----sessionUtil----'+key);
      if (key === 'current-user-uid' || key === '当前用户主键') {
        return this.getUserUid()
      } else if (key === 'current-user-id' || key === '当前用户编码') {
        return this.getUserId()
      } else if (key === 'current-user-name' || key === '当前用户名称') {
        return this.getUserName()
      } else if (key === 'current-depart-uid' || key === '当前部门主键') {
        return this.getDepartUid()
      } else if (key === 'current-depart-id' || key === '当前部门编码') {
        return this.getDepartId()
      } else if (key === 'current-depart-name' || key === '当前部门名称') {
        return this.getDepartName()
      } else if (key === 'current-sub-company-uid' || key === '当前分部组织主键') {
        return this.getSubCompanyUid()
      }  else if (key === 'current-sub-company-name' || key === '当前分部组织名称') {
        return this.getSubCompanyName()
      } else if (key === 'current-company-uid' || key === '当前组织主键') {
        return this.getCompanyUid()
      } else if (key === 'current-company-id' || key === '当前组织编码') {
        return this.getCompanyId()
      } else if (key === 'current-company-name' || key === '当前组织名称') {
        return this.getCompanyName()
      } else if (key === 'current-date' || key === '当前日期') {
        return (new Date()).format('yyyy-MM-dd')
      } else if (key === 'current-datetime' || key === '当前日期时间') {
        return new Date()
      } else if (key === 'current-year' || key === '当前年' || key === '本年') {
        return new Date().getFullYear()
      } else if (key === 'current-month' || key === '当前月' || key === '本月') {
        return new Date().getMonth() + 1
      }  else if (key === 'current-month-long') {
        let s = new Date().getMonth() + 1;
        return this.util.numPadStart(s,2);
      } else if (key === 'current-week' || key === '当前周' || key === '本周') {
        return util.getYearWeek()
      } else if (key === 'current-next-monday' || key === '下周一') { // 下周一
        return util.getNextMonday()
      } else if (key === 'current-month-first' || key === '本月第一天') { // 本月第一天
        return util.getCurrentMonthFirst()
      } else if (key === 'current-month-last' || key === '本月最后一天') { // 本月最后一天
        return util.getCurrentMonthLast()
      } else if (key === 'next-month-first' || key === '下月第一天') { // 下月第一天
        return util.getNextMonthFirst()
      } else if (key === 'next-month-last' || key === '下月最后一天') { // 下月最后一天
        return util.getNextMonthLast()
      } else {
        let sessionProj = null
        if (window.localStorage.getItem('_session_proj' + this.getUser().id)) {
          sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + this.getUser().id))
        } else if (vue.getFormConfig['_session_proj' + this.getUser().id]) {
          sessionProj = vue.getFormConfig['_session_proj' + this.getUser().id].data
          // console.log('------mainData-------', mainData, sessionProj)
        }
        if (sessionProj) {
          sessionProj = {
            'session-proj-code': sessionProj.PROJ_CODE_,
            'session-proj-id': sessionProj.PROJ_ID_,
            'session-proj-name': sessionProj.PROJ_NAME_,
            'session-proj-uid': sessionProj.PROJ_UID_
          }
          for (const edit in sessionProj) {
            if (key.indexOf(edit) > -1) {
              key = key.replace(new RegExp('{' + edit + '}', 'gm'), sessionProj[edit])
            }
          }
        }
        // 如果是占位符且没有匹配到参数
        if (key.indexOf('{') > -1) {
          return ''
        }
        return key
      }
    }
}
export const sessionUtil = new SessionUtil()



// WEBPACK FOOTER //
// ./src/utils/session.js